export default __webpack_public_path__ + "static/media/10C.9ed3d91b.png";